<template>
  <div class="on-focus__popular-list q-d-grid" v-if="sectionEnabled">
      <div class="autocomplete-popup__popular-products-container q-row q-position-relative q-pt-0">
        <PromotedProductContainer v-if="promotedProduct && promotedProductEnabled && canShowPromotedSection"
                                  :promoted-product="promotedProduct"
                                  :promoted-product-header="promotedProductHeader"/>

        <ProductsList :products-header="productsHeader"
                      :products-list="productsList"
                      :promoted-product-enabled="promotedProductEnabled"
                      :can-show-promoted-section="canShowPromotedSection"
        />
      </div>
    </div>
</template>

<script setup lang="ts">
import ProductsList from "./ProductsList.vue";
import PromotedProductContainer from '../PromotedProduct/PromotedProductContainer.vue'
import {defineProps} from "vue/dist/vue";

defineProps(['sectionEnabled', 'promotedProductEnabled', 'promotedProduct', 'promotedProductHeader', 'productsHeader', 'productsList', 'canShowPromotedSection'])



</script>

<style>
.autocomplete-popup__popular-products-container{
  min-height: 480px;
}
</style>

